export function $cdn(path: string) {
    return 'https://cdn.abundolive.se/' + path;
}

export namespace $cdn {
    export const upload_url = '/service/media/v1/upload';

    export function media(media: string, variant?: string) {
        if(media.includes('/'))
            return media;
        if(variant)
            media += '-' + variant;
        return $cdn('download/' + media);
    }

    export function asset(filename: string) {
        return $cdn('images/assets/' + filename);
    }
}
